import DashboardDynamicChartComponent from '@components/DashboardDynamicChartComponent';
import { Dashboard as DashboardInterface } from '@interfaces/ehss/Dashboard';
import Ticket from '@interfaces/ehss/ticket';
import ConfigService from '@services/global/Config';
import TicketService from '@services/TicketEvent';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import React from 'react';

import styled from '../../node_modules/styled-components';
import AppContext from '../services/Context';

type PropType = {
  fields?: string[]
  title?: string;
  description?: string[];
  options?: any;
  selectionText?: string;
  chartType?: string;
  queryStatus?: number;
  queryAuditedOut?: boolean;
  queryAuditorGuest?: boolean;
  isRisk?: boolean;
  useExtraFields?: boolean;
  processId?: string;
  

}

type StateType = {
  fieldSelectedLabel: any;
  loadingData: boolean;
  loadingUserFields: boolean;
  dashboardData: any;

  userFields: any[];
  loadingTickets: boolean;
  ticketsData: Ticket[];

  processId: string;
  infoId: string;
  localStorageData: boolean;
};

class DashboardFetchData extends React.Component<PropType, StateType> {


  private _configService: ConfigService = new ConfigService();
  private _ticketService: TicketService = new TicketService();

  private idUnit: any = undefined;


  private extraFieldSelectedId: string = '';

  private colors = [
    '#166df9'
  ]

  state: StateType = {
    fieldSelectedLabel: undefined,
    loadingData: false,
    dashboardData: undefined,
    userFields: [],
    loadingUserFields: false,
    loadingTickets: false,
    ticketsData: [],
    processId: '',
    infoId: '',
    localStorageData: false
  }

  constructor(props: any) {
    super(props);

    this.selectFieldChanged = this.selectFieldChanged.bind(this);
    this.onSearchExtraFieldDashboardData = this.onSearchExtraFieldDashboardData.bind(this);
  }

  componentDidMount() {
    const { useExtraFields } = this.props;

    if (useExtraFields == true) {
      this.getConfig();
    }
    else {
      this.getDashboard();
    }

  }

  setUnit(unit: string) {
    this.idUnit = unit;
  }
  setLocale(locale: any) {
    this.locale = locale;
  }

  getDashboard = async (field?: string, value?: string) => {

    await this.setState({
      processId: localStorage.getItem('processId') || '',
      infoId: localStorage.getItem('infoId') || ''
    })

    if(this.state.infoId && this.state.processId){
            
      await this.setState({loadingData: true, localStorageData: true})

      const year = new Date().getFullYear();
      const query = {
        status: this.props.queryStatus,
        unit: this.idUnit,
        from: new Date(`${year}-01-01T00:00:00Z`).getTime(),
        field: field || undefined,
        value: value || undefined,
        auditedOut: this.props.queryAuditedOut,
        auditorGuest: this.props.queryAuditorGuest,
      }
      try {
        if (this.props.isRisk === undefined) {
          const data = await this._ticketService.getDashboard(query, this.state.processId);
          this.formatDataToGraph(data);
        }
        else {
          const data = await this._ticketService.getDashboardRisk(query, this.state.processId, this.state.infoId);
          this.formatDataToGraph(data);
        }

        await this.setState({
          loadingData: false,
        })
      } catch (e) {
        NotificationComponent.Notify('error', I18n.l('dashboard.errors.apiFetchError'), e);
        console.log("ERROR: ", e);
        await this.setState({
          loadingData: false,
        })
      }

    }
  }


  getConfig = async () => {
    if(this.state.localStorageData){
      await this.setState({
        loadingUserFields: true
      });
      try {
        const response = await this._configService.getGLOBAL(['userFields']);
  
        if (response.userFields != undefined) {
          await this.setState({
            userFields: response.userFields,
          });
        }
        await this.setState({
          loadingUserFields: false
        });
      } catch (e) {
        await this.setState({
          loadingUserFields: false
        });
      }
    }
  }

  selectFieldChanged = (field: any) => {
     this.extraFieldSelectedId = this.getExtraFieldIdByName(field);
  }

  onSearchExtraFieldDashboardData(inputValue: string) {
    this.getDashboard(this.extraFieldSelectedId, inputValue);
  }

  getExtraFieldIdByName(fieldName: string) {
    const field = this.state.userFields.find((item: any) =>
      item.name === fieldName
    );

    if (field) {
      return field.id;
    }
  }

  getExtraFieldsNames() {
    let names: string[] = [];
    this.state.userFields.forEach((field: any) => {
      names.push(field.name);
    })
    return names;
  }

  formatDataToGraph = async (data: DashboardInterface[]) => {
    let chartLabels: string[] = [
      I18n.l('dashboard.labels.1'),
      I18n.l('dashboard.labels.2'),
      I18n.l('dashboard.labels.3'),
      I18n.l('dashboard.labels.4'),
      I18n.l('dashboard.labels.5'),
      I18n.l('dashboard.labels.6'),
      I18n.l('dashboard.labels.7'),
      I18n.l('dashboard.labels.8'),
      I18n.l('dashboard.labels.9'),
      I18n.l('dashboard.labels.10'),
      I18n.l('dashboard.labels.11'),
      I18n.l('dashboard.labels.12'),
    ];
    let chartDatasets: any[] = [];

    let possibleColors = this.colors;
    const colors = [...possibleColors];

    const avg = (risks?: number[]): number => {
      let sum, avg = 0;

      // dividing by 0 will return Infinity
      // arr must contain at least 1 element to use reduce
      if (risks && risks.length) {
        sum = risks.reduce((a, b) => a + b, 0);
        avg = sum / risks.length;
      }
      return avg;
    }

    let chartData = undefined;
    let hasData: boolean = false;
    //GAMBS: refazer esse metodo de mostrar o grafico
    if (data.length) {
      let values: any[] = [];
      let dataset: any = undefined;
      if (this.props.isRisk) {
        // let valueJan: number = data.filter(e => e.month === 1).map(e => e.count).reduce((a, b) => a + b, 0);
        
        let valueJan: number = avg(data.filter(e => e.month === 1).map(e => avg(e.values)));
        let valueFev: number = avg(data.filter(e => e.month === 2).map(e => avg(e.values)));
        let valueMar: number = avg(data.filter(e => e.month === 3).map(e => avg(e.values)));
        let valueApr: number = avg(data.filter(e => e.month === 4).map(e => avg(e.values)));
        let valueMay: number = avg(data.filter(e => e.month === 5).map(e => avg(e.values)));
        let valueJun: number = avg(data.filter(e => e.month === 6).map(e => avg(e.values)));
        let valueJul: number = avg(data.filter(e => e.month === 7).map(e => avg(e.values)));
        let valueAug: number = avg(data.filter(e => e.month === 8).map(e => avg(e.values)));
        let valueSep: number = avg(data.filter(e => e.month === 9).map(e => avg(e.values)));
        let valueOct: number = avg(data.filter(e => e.month === 10).map(e => avg(e.values)));
        let valueNov: number = avg(data.filter(e => e.month === 11).map(e => avg(e.values)));
        let valueDec: number = avg(data.filter(e => e.month === 12).map(e => avg(e.values)));
        

        values.push(valueJan.toFixed(2), valueFev.toFixed(2), valueMar.toFixed(2), valueApr.toFixed(2), valueMay.toFixed(2), valueJun.toFixed(2),
          valueJul.toFixed(2), valueAug.toFixed(2), valueSep.toFixed(2), valueOct.toFixed(2), valueNov.toFixed(2), valueDec.toFixed(2));
      }
      else {
        let valueJan: number = data.filter(e => e.month === 1).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueFev: number = data.filter(e => e.month === 2).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueMar: number = data.filter(e => e.month === 3).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueApr: number = data.filter(e => e.month === 4).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueMay: number = data.filter(e => e.month === 5).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueJun: number = data.filter(e => e.month === 6).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueJul: number = data.filter(e => e.month === 7).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueAug: number = data.filter(e => e.month === 8).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueSep: number = data.filter(e => e.month === 9).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueOct: number = data.filter(e => e.month === 10).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueNov: number = data.filter(e => e.month === 11).map(e => e.count).reduce((a, b) => a + b, 0);
        let valueDec: number = data.filter(e => e.month === 12).map(e => e.count).reduce((a, b) => a + b, 0);
        values.push(valueJan, valueFev, valueMar, valueApr, valueMay, valueJun,
          valueJul, valueAug, valueSep, valueOct, valueNov, valueDec);
      }
      if (values.length > 0) {
        hasData = true;
      }

      var index = Math.floor(Math.random() * ((possibleColors.length - 1) - 0 + 1)) + 0;

      const color = colors[index];
      colors.splice(index, 1);

      dataset = ({
        label: I18n.l('dashboard.dones'),
        data: values,
        fill: false,
        backgroundColor: color,
        borderColor: color,
      });

      chartDatasets.push(dataset);
      chartData = {
        labels: chartLabels,
        datasets: chartDatasets
      }
    }

    await this.setState({
      dashboardData: (hasData ? chartData : undefined) || undefined,
    })
  }

  render() {
    const {
      selectionText,
      description,
      title,
      chartType,
      options,
      useExtraFields
    } = this.props;
    const {
      dashboardData,
      loadingData,
      loadingUserFields
    } = this.state;
    return (
      <AppContext.Consumer>
        {({ locale, activeUnitId }) => (
          this.setUnit(activeUnitId),
          this.setLocale(locale),
          <Wrapper>
            <DashboardDynamicChartComponent
              chartData={dashboardData}
              chartType={chartType || ''}
              description={description}
              selectionText={selectionText}
              fields={this.getExtraFieldsNames()}
              title={title}
              options={options}
              loading={loadingData}
              useExtraFields={useExtraFields || false}
              onHandleExtraFieldChange={this.selectFieldChanged}
              onSearchExtraFieldData={this.onSearchExtraFieldDashboardData}
              loadingUserFields={loadingUserFields}

            />
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const Wrapper = styled.div`
    .title2{
        font-weight: bold;
    }
    .title3{
        font-weight: bold;
    }

    .description:not(:first-child){
        margin-top: 9px;
    }

    .chart{
        width: 750px;
    }
`;

export default DashboardFetchData;